import gql from 'graphql-tag';
import { RESPONSE_COMPARE_REQUEST_TYPE } from './ResponseCompareRequestType.gql';

export const ALL_COMPARISON_REQUEST_FROM_USER = gql`
  ${RESPONSE_COMPARE_REQUEST_TYPE}
  query allComparisonRequestFormUser($orderBy: [String], $offset: Int, $first: Int) {
    allComparisonRequestFormUser(orderBy: $orderBy, offset: $offset, first: $first) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...ResponseCompareRequestType
        }
        cursor
      }
      edgeCount
      totalCount
    }
  }
`;
